import { createAction } from '@reduxjs/toolkit';
import * as ActionTypes from './types';
import {
    FETCH_APPLICATION_SETTINGS,
    FETCH_APPLICATION_SETTINGS_FAILED,
    FETCH_APPLICATION_SETTINGS_SUCCESS,
} from './types';

interface GeneralResponse {
    body: {
        data: ApiApplicationSettings;
    };
}
export interface AragButtons {
    code: string;
    isExternal: boolean;
    position: number;
    titleForBigScreens: string;
    titleForSmallScreens: string;
    url: string;
}
interface ApiApplicationSettings {
    mobileScreenSizeWidth: number;
    maxAttachmentSizeInMB: number;
    enableCaptcha: boolean;
    enableAutoSave: boolean;
    isSwitchingLanguageEnabled: boolean;
    aragTelephoneNumber: string;
    aragSubText: string;
    aragImageHeroArea: string;
    aragHeaderText: string;
    aragCollapsedImageHeroArea: string;
    aragButtons: Array<AragButtons>;
}
export const fetchApplicationSettings = createAction<
    fetchApplicationSettingsAction | {}
>(ActionTypes.FETCH_APPLICATION_SETTINGS);
export const fetchApplicationSettingsSuccess =
    createAction<fetchApplicationSettingsSuccessAction>(
        ActionTypes.FETCH_APPLICATION_SETTINGS_SUCCESS,
    );
export const fetchApplicationSettingsFailed =
    createAction<fetchApplicationSettingsFailedAction>(
        ActionTypes.FETCH_APPLICATION_SETTINGS_FAILED,
    );

export interface fetchApplicationSettingsAction {
    type?: typeof FETCH_APPLICATION_SETTINGS;
}

export interface fetchApplicationSettingsSuccessAction {
    type: typeof FETCH_APPLICATION_SETTINGS_SUCCESS;
    payload: GeneralResponse;
}

export interface fetchApplicationSettingsFailedAction {
    type: typeof FETCH_APPLICATION_SETTINGS_FAILED;
}
